import { API_BASE_URL } from "../config";
import { globalNavigate } from "../utilities/globalNavigation";

const buildUrl = (path, params = {}) => {
	const url = new URL(`${API_BASE_URL || "http://localhost:5000"}${path}`);
	Object.entries(params).forEach(([key, value]) => {
		// Skip only undefined and null values, but include empty strings for filters
		if (value === undefined || value === null) return;
		if (Array.isArray(value)) {
			// Append as repeated params (e.g. user_role=A&user_role=B) so the
			// server's query parser reconstructs it as an array (multi-select filters).
			value.forEach((item) => {
				if (item === undefined || item === null) return;
				url.searchParams.append(key, String(item));
			});
			return;
		}
		url.searchParams.set(key, String(value));
	});
	return url.toString();
};

const isAuthExpiredResponse = (status, payload = {}) =>
	status === 401 ||
	payload?.message === "Session expired or invalid" ||
	payload?.message === "Invalid or expired JWT token";

const redirectToLogin = () => {
	localStorage.clear();
	if (window.location.pathname !== "/login") {
		globalNavigate("/login", { external: true });
	}
};

export const getUserAnalyticsDashboard = async (params = {}, options = {}) => {
	try {
		const token = localStorage.getItem("token");
		const url = buildUrl("/openpanel-analytics/user-dashboard", params);
		const response = await fetch(url, {
			method: "GET",
			signal: options.signal,
			headers: {
				"Content-Type": "application/json",
				...(token ? { Authorization: `Bearer ${token}` } : {}),
			},
		});

		const payload = await response.json().catch(() => ({}));

		if (!response.ok) {
			if (isAuthExpiredResponse(response.status, payload)) {
				redirectToLogin();
				return {};
			}

			return {
				success: false,
				status: response.status,
				message:
					payload?.message ||
					payload?.error_message ||
					`Failed to load user analytics (${response.status})`,
			};
		}

		return payload;
	} catch (error) {
		if (error?.name === "AbortError") {
			return { success: false, aborted: true };
		}
		return {
			success: false,
			message: error?.message || "Failed to load user analytics.",
		};
	}
};
